"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _Button = _interopRequireDefault(require("../Button"));
var _VisuallyHidden = _interopRequireDefault(require("../VisuallyHidden"));
const _excluded = ["className", "component", "links"];
/**
 * A link that allows keyboard users to skip past lengthy blocks and jump to specific content areas on a web page.
 *
 * [Storybook](https://busbud.github.io/design-system/?path=/docs/components-navigation-skiplink--page)
 */
const SkipLink = /*#__PURE__*/_react.default.forwardRef(function SkipLink(props, ref) {
  const {
      className,
      component: Component = 'div',
      links
    } = props,
    other = (0, _objectWithoutProperties2.default)(props, _excluded);
  return (
    /*#__PURE__*/
    // @ts-ignore TS2590
    _react.default.createElement(Component, (0, _extends2.default)({
      className: className,
      ref: ref
    }, other), links.map((_ref, index) => {
      let {
        targetId,
        name,
        onClick
      } = _ref;
      const handleClick = event => {
        onClick?.(event);
        event.preventDefault(); // Prevents adding #id fragment to the URL address
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
          targetElement.focus();
          targetElement.scrollIntoView(true);
        }
      };
      return /*#__PURE__*/_react.default.createElement(_VisuallyHidden.default, {
        isVisibleOnFocus: true,
        key: index
      }, /*#__PURE__*/_react.default.createElement(_Button.default, {
        href: `#${targetId}`,
        onClick: handleClick,
        size: "md"
      }, name));
    }))
  );
});
var _default = exports.default = SkipLink;